export default __webpack_public_path__ + "static/media/calledtofly.3b04eccb.png";